/* src/components/reconcile/reconcile.component.scss */
.content {
  background: var(--background);
  max-height: calc(var(--height) * 0.9);
  overflow-y: auto;
  display: flex;
  padding: 10px;
  width: 100%;
  position: relative;
  flex-direction: column;
}
.content .heading {
  padding: 5px;
}
.content .transactions {
  max-height: calc(var(--height) * 0.55);
  width: 100%;
  overflow-y: auto;
  padding: 5px;
  background: rgba(var(--ion-color-dark-rgb), 0.1);
}
.content .transactions table {
  width: 100%;
}
.content .transactions table td,
.content .transactions table th {
  padding: 5px;
  border: 1px solid black;
}
.content .buttons {
  padding: 5px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
/*# sourceMappingURL=reconcile.component.css.map */
